import { azureDb } from "@/lib/azure/compat-client"

export function generateFileName(originalName: string, prefix = ""): string {
  const timestamp = Date.now()
  const randomString = Math.random().toString(36).substring(2, 15)
  const extension = originalName.split(".").pop()
  return `${prefix}${timestamp}-${randomString}.${extension}`
}

export async function uploadFile(
  container: string,
  path: string,
  file: File,
): Promise<{ data: { path: string } | null; error: { message: string } | null }> {
  return azureDb.storage.from(container).upload(path, file)
}
